import React from 'react';
import { Formik, Field, Form } from 'formik';
import { inject, observer } from 'mobx-react';
import { observable } from 'mobx';
import classnames from 'classnames';
import { withRouter, Link } from "react-router-dom";
import { matchPath } from 'react-router';
import queryString from "query-string";



const validate = values => {
	let errors = {};
	//if (!values.password) {
	//	errors.password = 'Required';
	//}
	if (values.password.length < 10) {
		errors.password = 'The password should consist of at least 10 characters';
	}

	return errors;
};

@inject("store")
@observer
class ResetPassword extends React.Component {
	@observable loading = true;
	@observable verified = false;
	@observable verifyError = false;
	@observable resetcode = "";
	@observable error = "";
	@observable userId = 0;
	@observable username = "";
	@observable passwordFieldType = "password";
	
	@observable submitted = false;
	@observable action = "";


	constructor(props) {
		super(props);
		const { store } = this.props;
		this.store = store;
		
		this.togglePasswordFieldType = this.togglePasswordFieldType.bind(this);

	}

	componentDidMount() {
		const { location, match, store } = this.props;

		const parsed = queryString.parse(location.search);
		const resetToken = parsed.reset;
		
		const resetRegexp = /^(?<id>\d+)-(?<token>.+)$/;
		
		
		
		// const toolbarRouter = store.navigation.toolbarRouter;
		// const verifyPathRegex = "/:customerId/verify/:id/:verifycode";
		// const passwordResetPathRegex = "reset=:id-:resetcode";
		// const verifyMatch = matchPath(toolbarRouter.location.pathname, { path: verifyPathRegex });
		// const passwordResetMatch = matchPath(location.search, { path: passwordResetPathRegex });
		// console.log("passwordResetMatch", passwordResetMatch, location.search);
		
		const passwordResetMatch = resetToken.match(resetRegexp);
		if (passwordResetMatch && passwordResetMatch.groups && passwordResetMatch.groups.id && passwordResetMatch.groups.token) {
			this.action = "reset";
			this.resetcode = passwordResetMatch.groups.token;
			this.userId = passwordResetMatch.groups.id;
			store.account.verifyToken(this.userId, null, this.resetcode).then(res => {
				this.loading = false;
				this.username = res.username;
			}, errorResponse => {
				this.error = errorResponse.errors[0];
				this.loading = false;
			});
		}
		// else if (verifyMatch && verifyMatch.isExact) {
		// 	this.action = "verify";
		// 	this.userId = verifyMatch.params.id;
		// 	this.verifycode = verifyMatch.params.verifycode;
		// 	store.account.verifyToken(this.userId, this.verifycode, null).then(res => {
		// 		if (res.redirect) {
		// 			location.href = "/";
		// 		}
		// 		if (res.reload) {
		// 			location.reload();
		// 		}
		// 		this.loading = false;
		// 	}, errorResponse => {
		// 		this.error = errorResponse.errors[0];
		// 		this.loading = false;
		// 	});
		//
		// }
		else {
			this.error = "No token provided."
			
			this.loading = false;
		}

		this.submitted = false;

	}

	togglePasswordFieldType(e) {
		e.preventDefault();
		this.passwordFieldType = this.passwordFieldType === "password" ? "text" : "password";
	}

	render() {
		const account = this.props.store.account;
		const dictionary = this.props.store.navigation.dictionary;
		const match = this.props.match;
		let matchUrl = match.url;
		if (matchUrl.length === 1 && matchUrl[0] === "/") {
			matchUrl = "";
		}

		if (this.submitted) {
			return (
				<React.Fragment>


					<div className="card mt-4">
						<div className="card-body">
							<h2>{dictionary["ResetPassword.Thankyou"]}Tack!</h2>
							<p>{dictionary["ResetPassword.ThankyouText"]}</p>
							<button className="btn btn-success" type="submit" onClick={() => { document.location.href = "/"; }}>{dictionary["ResetPassword.Continue"]}</button>
						</div>
					</div></React.Fragment>
			);

		}


		if (this.loading) {
			return (<div>Loading...</div>);
		}
		if (this.error) {
			return (<div className="card mt-4">
				<div className="card-body text-sm" >
					
					<strong>{dictionary["ResetPassword.Continue"]}</strong>
					
					<p className="text-sm">
						{this.error}
					</p>

					
					<a className="btn btn-sm btn-success" href={account.LoginUrl + "/#resetpassword"}>{dictionary["ResetPassword.GoToReset"]}</a> <br/><br/>
					<a className="btn btn-sm btn-success" href={account.LoginUrl}>{dictionary["ResetPassword.GoToLogin"]}</a><br /><br/>
					

				</div>
			</div>);
		}

		return (
			<React.Fragment>
				{this.verified ? <div className="alert alert-success fade show text-center margin-bottom-1x"><i className="icon-camera"></i><strong>E-mail verified:</strong> Please choose your password and continue</div> : ""}

				<Formik
					verified={this.verified}
					passwordFieldType={this.passwordFieldType}
					togglePasswordFieldType={this.togglePasswordFieldType}
					initialValues={{
						password: '',
						username: this.userName
					}}

					validate={validate}
					onSubmit={(values, actions) => {
						const updateValues = {
							...values,
							resetcode: this.resetcode,
							verifycode: this.verifycode,
							userId: this.userId
						};
						store.account.resetAccount(updateValues).then(
							status => {
								console.debug(status);
								actions.setSubmitting(false);
								this.submitted = true;
								//document.location.href = "/";
							},
							error => {
								actions.setSubmitting(false);

								//Object.keys(error.errors).forEach(key => {
								//	error.errors[key].forEach(errorRow => {
								//		actions.setFieldError(key.toLowerCase(), errorRow);
								//	});
								//});

								console.debug(error.errors.length);
								if (error.errors.length > 0) {
									console.debug("set field error");
									if (error.errors[0] === "Invalid token.") {
										this.error = "The link has already been used or has expired";
									} else {
										actions.setFieldError("custom", error.errors[0]);
									}
								}

								actions.setSubmitting(false);
							}
						);

					}}
					render={({ errors, touched, isSubmitting, isValid, verified, passwordFieldType, togglePasswordFieldType }) => {

						return (
							<Form id="reset-form">

								<div className="card mt-4">
									<div className="card-body">
										<h2>{dictionary["ResetPassword.Title"]}</h2>

										<p className="text-sm">{dictionary["ResetPassword.Text"]}</p>

										<div className="form-group">

											<div className={classnames("form-group",
												"input-group",
												{ 'has-warning': errors.password && touched.password })}>
												<Field className="form-control"
													autoFocus
													name="password"
													type="password"
													placeholder={dictionary["ResetPassword.PasswordPlaceholder"]}
													autoComplete="new-password"
												/>
												<Field className="form-control"
													   hidden
													   name="username"
													   autoComplete="username"
													   
												/>


												<span className="input-group-addon"><i className="material-icons lock"></i></span>
												{errors.password &&
													touched.password &&
													<div className="form-control-feedback">{errors.password}</div>}
											</div>
											{errors.custom && <div>
												<div className="alert alert-danger fade show text-center margin-bottom-1x"><i className="icon-bell"></i>&nbsp;&nbsp;{errors.custom}</div>
											</div>}

											<button className="btn btn-success" type="submit" disabled={!isValid || isSubmitting}>{dictionary["ResetPassword.SaveAndContinue"]}</button>

										</div>
									</div>


								</div>

							</Form>
						);
					}}
				/>
			</React.Fragment>
		);

	}
}


export default withRouter(ResetPassword)